/**
 * Midwest Dental disclaimer content per trigger question.
 * Each key maps to the question component key.
 * Fields: title, subtitle, paragraphText, contactPhone
 */
const midwestDentalDisclaimerMessages = {
  q1HaveYouCompletedAnOvernightSleepStudy: {
    subtitle:
      "A completed overnight sleep study is required before scheduling an oral appliance consultation.",
    paragraphText:
      "Please speak with your primary care provider about a referral, or call us directly, we're happy to help.",
    contactPhone: "(312) 676-9892",
  },
  qDoYouHaveAtLeast6StableTeethRemainingOnYourLowerArch: {
    title: "Thank You, A Team Member Will Reach Out to You Soon!",
    subtitle:
      "Having fewer than 6 teeth on the lower jaw can affect your eligibility for oral appliance therapy.",
    paragraphText:
      "A member of our team will reach out to review your specific situation and ensure we can schedule your appointment at the right time.",
  },
  q7AreYouCurrentlyUndergoingOrthodonticTreatmentBracesClearAlignersRetainersEtc:
    {
      title: "Thank You, A Team Member Will Reach Out to You Soon!",
      subtitle:
        "Patients currently undergoing orthodontic treatment, including braces, clear aligners, or active retainers are not eligible to begin oral appliance therapy until treatment is complete.",
      paragraphText:
        "A member of our team will reach out to you to ensure we can schedule your appointment at the right time.",
    },
  q5DoYouHaveAnyPlannedOrRecommendedDentalWorkAreYouAwareOfAnyDentalWorkYouMayNeedOrPlanToHaveDoneInTheNext5Years:
    {
      title: "Thank You, A Team Member Will Reach Out to You Soon!",
      subtitle:
        "Planned or upcoming dental work can directly affect the fit and longevity of an oral appliance.",
      paragraphText:
        "A member of our team will reach out to discuss your specific dental plan and ensure we schedule your appointment at the right time to protect your investment.",
    },
};

const fallbackDisclaimerMessage = {
  subtitle: "",
  paragraphText: "Based on your response, please contact us for further assistance.",
  contactPhone: "(312) 676-9892",
};

export const getDisclaimerMessage = (questionKey) => {
  return midwestDentalDisclaimerMessages[questionKey] || fallbackDisclaimerMessage;
};
